function onCheckoutNotStarted(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onCheckoutNotStarted', e);
  }

  // Do something stub onCheckoutNotStarted

  return;
}

export default onCheckoutNotStarted;
